import {
  DeviceReportTemplate,
  DeviceReportTemplateField,
  DeviceReportTemplateOption
} from '../types/reportTemplate';

const normalizeString = (value: unknown): string | null => {
  if (value === null || value === undefined) {
    return null;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return null;
};

const normalizeCode = (value: unknown): string | null => {
  const normalized = normalizeString(value);
  return normalized ? normalized.toLowerCase() : null;
};

const normalizeBoolean = (value: unknown): boolean => {
  if (value === true || value === 1) {
    return true;
  }
  if (value === false || value === 0) {
    return false;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'ja';
  }
  return false;
};

const normalizeOption = (raw: any): DeviceReportTemplateOption | null => {
  const value = normalizeString(raw?.value ?? raw?.optionValue ?? raw?.option_value);
  if (!value) {
    return null;
  }

  return {
    id: normalizeString(raw?.id),
    value,
    description: normalizeString(raw?.description)
  };
};

const normalizeField = (raw: any): DeviceReportTemplateField | null => {
  if (!raw || typeof raw !== 'object') {
    return null;
  }

  const name = normalizeString(raw.name ?? raw.label);
  if (!name) {
    return null;
  }

  const options = Array.isArray(raw.options) ? raw.options.map(normalizeOption).filter(Boolean) : [];

  return {
    id: normalizeString(raw.id),
    name,
    dataType: normalizeCode(raw.dataType ?? raw.data_type),
    inputType: normalizeCode(raw.inputType ?? raw.input_type),
    mandatory: normalizeBoolean(raw.mandatory),
    defaultValue: normalizeString(raw.defaultValue ?? raw.default_value),
    options
  };
};

export const normalizeDeviceReportTemplate = (raw: any): DeviceReportTemplate | null => {
  if (!raw || typeof raw !== 'object') {
    return null;
  }

  const fields = Array.isArray(raw.fields) ? raw.fields.map(normalizeField).filter(Boolean) : [];

  return {
    deviceId: normalizeString(raw.deviceId ?? raw.device_id),
    deviceIdentifier: normalizeString(raw.deviceIdentifier ?? raw.identifier),
    equipmentType: normalizeString(raw.equipmentType ?? raw.deviceType),
    templateId: normalizeString(raw.templateId ?? raw.template_id),
    templateName: normalizeString(raw.templateName ?? raw.template),
    fields
  };
};
